
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Calque_1","data-name":"Calque 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 800 800"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('title',[_v('p')]),_c('g',[_c('path',{staticClass:"cls-1",attrs:{"d":"M456.57,400,585.62,271a10,10,0,0,0,0-14.14l-42.43-42.43a10,10,0,0,0-14.14,0L400,343.43l-129-129a10,10,0,0,0-14.14,0l-42.43,42.43a10,10,0,0,0,0,14.14L343.43,400l-129,129a10,10,0,0,0,0,14.14l42.43,42.43a10,10,0,0,0,14.14,0L400,456.57l129,129.05a10,10,0,0,0,14.14,0l42.43-42.43a10,10,0,0,0,0-14.14Z"}}),_c('path',{staticClass:"cls-2",attrs:{"d":"M400,0C179.09,0,0,179.09,0,400S179.09,800,400,800,800,620.91,800,400,620.91,0,400,0ZM585.62,529.05a10,10,0,0,1,0,14.14l-42.43,42.43a10,10,0,0,1-14.14,0l-129-129L271,585.62a10,10,0,0,1-14.14,0l-42.43-42.43a10,10,0,0,1,0-14.14L343.43,400l-129-129a10,10,0,0,1,0-14.14l42.43-42.43a10,10,0,0,1,14.14,0L400,343.43l129-129a10,10,0,0,1,14.14,0l42.43,42.43a10,10,0,0,1,0,14.14L456.57,400Z"}})])])
          )
        }
      }
    